import { ClientReplenishmentRequestFolder } from "@redotech/redo-views-common/folders";
import { ClientReplenishmentRequestView } from "@redotech/redo-views-common/views";
import * as z from "zod";
import { null as zNull } from "zod";

export const getReplenishmentRequestViewsAndFolders = {
  name: "getReplenishmentRequestViewsAndFolders" as const,
  input: zNull(),
  output: z.object({
    folders: z.array(ClientReplenishmentRequestFolder),
    views: z.array(ClientReplenishmentRequestView),
  }),
};
